module.exports = __webpack_public_path__ + "img/anl.a786b501.png";